import { FormattedMessage } from 'react-intl';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { EditTargetsContent } from './edit-targets-content';

interface EditTargetsDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export function EditTargetsDialog({
  isOpen,
  setIsOpen,
}: EditTargetsDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="min-w-0 sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>
            <FormattedMessage
              defaultMessage="Edit Targets"
              description="Dialog title: change budget, CPA, and conversion for the goal"
            />
          </DialogTitle>
        </DialogHeader>

        <EditTargetsContent />
      </DialogContent>
    </Dialog>
  );
}
